import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestSATSurveyAnswers} from "../../shared/Api";
import {errorToast, infoToast, successToast} from "../../shared/helper/ToastHelper";
import {CandidateFilterParams} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {saveByteArray} from "../../shared/Utils";

const DownloadSATSurveyResults = (props: CandidateFilterParams ) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const downloadAnswers = useMutation(()=>
    {
      infoToast(toast, "Procesando respuestas")
      return requestSATSurveyAnswers(props)
    }, {
    onSuccess: (TData) => {
      successToast(toast, "Descargando respuestas");
      saveByteArray("Respuestas satisfacción "+props.startDateValue+"-"+props.endDateValue, TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando respuestas");
    },
  });

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen} >
          Respuestas de la encuesta de satisfacición
        </Button>
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar respuestas</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadAnswers.mutate()}
              >
                Descargar Respuestas
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadSATSurveyResults;
